import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { Subscription, forkJoin } from 'rxjs';
import { Alert } from "src/app/classes/alert";
import { AlertboxComponent } from "src/app/general/alertbox/alertbox.component";
import { DialogsService } from "src/app/services/dialogs.service";
import { RealCompetitionService } from "src/app/services/real-competition.service";
@Component({
    selector: 'app-championship-single',
    templateUrl: './championship-single.component.html',
    styleUrls: ['./championship-single.component.scss']
})
export class championshipComponent implements OnInit{
    busy: Subscription;
    pathList: Array<Array<string>>;
    faPlus = faPlusCircle;
    championForm = this.fb.group({});
    rcompObject = {}
    @ViewChild('alertbox1', { static: false }) alertbox1: AlertboxComponent;
    constructor(private router: Router, private fb: FormBuilder, private realCompetitionService: RealCompetitionService, private dialogsService: DialogsService){
        this.pathList = [['Create Realcompetition', 'realcompetition/create']];
        this.championForm = this.fb.group({
            id: new FormControl({value: '0', disabled: true}),
            description: new FormControl({value: '', disabled: false}),
            data_inizio: new FormControl({value: '', disabled: false}),
            data_fine: new FormControl({value: '', disabled: false}),
        });
    }

    validateInsert(): Boolean {
        let response = true
        let formValues = this.championForm.value
        Object.keys(formValues).forEach(key => { 
            
            if (formValues[key] === '' || formValues[key] === null){
                
                response = false
                
            }
        })
        return response
        
    }
    validateDate(): Boolean {

        let formValues = this.championForm.value
        if (formValues['data_inizio'] > formValues['data_fine']){
            return true
        }
        return false
    }
    saveItem(){
        let formValues = this.championForm.value

        const validation = this.validateInsert()
        const validateDates = this.validateDate()
        if (!validation){
            const ValidationAlert: Alert = new Alert();
            ValidationAlert.msg = "Non tutti i campi sono stati compilati";
            ValidationAlert.timeout = 5000;
            ValidationAlert.type = 'danger';
            this.alertbox1.alerts = [];
            this.alertbox1.alerts.push(ValidationAlert)
        }
        else if(validateDates){
            const ValidationAlert: Alert = new Alert();
            ValidationAlert.msg = "La data di fine non può essere antecedente alla data di inizio";
            ValidationAlert.timeout = 5000;
            ValidationAlert.type = 'danger';
            this.alertbox1.alerts = [];
            this.alertbox1.alerts.push(ValidationAlert)
        }
        else{
            this.rcompObject = {
                'description': formValues['description'],
                'active': 1,
                'data_inizio': formValues['data_inizio'],
                'data_fine': formValues['data_fine']
            }

            this.busy = this.realCompetitionService.create(this.rcompObject).subscribe(rcomp => {
            try{
                this.dialogsService.confirm("Creazione club", "Desideri procedere nella creazione dei club per il tuo campionato?", "Si", "No").then(ok => {
                    if (ok) {
                        this.router.navigateByUrl('/real_club/0');
                    }
                });
            } catch(error) {
                const ErrorAlert: Alert = new Alert();
                ErrorAlert.msg = "Errore nel salvataggio della competizione";
                ErrorAlert.timeout = 5000;
                ErrorAlert.type = 'danger';
                this.alertbox1.alerts = [];
                this.alertbox1.alerts.push(ErrorAlert)
            }
            })
        }
    }
    dialogConfirm(id) {
        this.router.navigateByUrl('/real_club/0');
    }

    ngOnInit(): void {
        let formValues = this.championForm.value
        formValues['id'] = 0
    }
}